// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanBasedBidPackagePage_OriginatingProjectQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PlanBasedBidPackagePage_OriginatingProjectQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string }>, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
   };

export type PlanBasedBidPackagePageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PlanBasedBidPackagePageQuery = { __typename?: 'Query', bidPackageGroup: { __typename?: 'BidPackageGroup', id: string, bidPackages: Array<{ __typename?: 'BidPackage', id: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }
        | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
      >, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, requests: Array<{ __typename?: 'BidPackageRequest', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, tradePartner: { __typename?: 'TradePartner', id: string } }>, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, bidPlanGroups: Array<{ __typename?: 'BidPlanGroup', id: string, order: number, globalOption?: { __typename?: 'GlobalOption', id: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, globalOptionType: { __typename?: 'GlobalOptionType', id: string }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string }> }> }> }> } };

export type PlanBasedBidPackagePage_OriginatingProject_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type PlanBasedBidPackagePage_OriginatingProject_Region_Fragment = { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined };

export type PlanBasedBidPackagePage_OriginatingProject_Market_Fragment = { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type PlanBasedBidPackagePage_OriginatingProject_Community_Fragment = { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string }>, market: { __typename?: 'Market', id: string, name: string } };

export type PlanBasedBidPackagePage_OriginatingProject_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type PlanBasedBidPackagePage_OriginatingProject_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type PlanBasedBidPackagePage_OriginatingProject_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type PlanBasedBidPackagePage_OriginatingProject_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type PlanBasedBidPackagePage_OriginatingProjectFragment =
  | PlanBasedBidPackagePage_OriginatingProject_StandaloneProject_Fragment
  | PlanBasedBidPackagePage_OriginatingProject_Region_Fragment
  | PlanBasedBidPackagePage_OriginatingProject_Market_Fragment
  | PlanBasedBidPackagePage_OriginatingProject_Community_Fragment
  | PlanBasedBidPackagePage_OriginatingProject_Subdivision_Fragment
  | PlanBasedBidPackagePage_OriginatingProject_Lot_Fragment
  | PlanBasedBidPackagePage_OriginatingProject_Structure_Fragment
  | PlanBasedBidPackagePage_OriginatingProject_Unit_Fragment
;

export type PlanBasedBidPackagePage_BidPackageFragment = { __typename?: 'BidPackage', id: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
  >, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, requests: Array<{ __typename?: 'BidPackageRequest', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, tradePartner: { __typename?: 'TradePartner', id: string } }>, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, bidPlanGroups: Array<{ __typename?: 'BidPlanGroup', id: string, order: number, globalOption?: { __typename?: 'GlobalOption', id: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, globalOptionType: { __typename?: 'GlobalOptionType', id: string }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string }> }> }> };

export type BidPlanGroupFieldsFragment = { __typename?: 'BidPlanGroup', id: string, order: number, globalOption?: { __typename?: 'GlobalOption', id: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, globalOptionType: { __typename?: 'GlobalOptionType', id: string }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string }> }> };

export const PlanBasedBidPackagePage_OriginatingProjectFragmentDoc = gql`
    fragment PlanBasedBidPackagePage_OriginatingProject on Project {
  ...Named
  market {
    ...Named
  }
  ... on Community {
    id
    productOfferings {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const BidPlanGroupFieldsFragmentDoc = gql`
    fragment BidPlanGroupFields on BidPlanGroup {
  id
  order
  globalOption {
    id
  }
  dimensions {
    id
    globalOptionType {
      id
    }
    globalOptions {
      id
    }
  }
}
    `;
export const PlanBasedBidPackagePage_BidPackageFragmentDoc = gql`
    fragment PlanBasedBidPackagePage_BidPackage on BidPackage {
  id
  bidPackageGroup {
    id
  }
  costCodes {
    ...Named
  }
  projects {
    ...Named
    market {
      ...Named
    }
  }
  costType {
    code
    name
  }
  requests {
    id
    archivedAt
    tradePartner {
      id
    }
  }
  productOfferings {
    id
    name
  }
  bidPlanGroups {
    ...BidPlanGroupFields
  }
}
    ${NamedFragmentDoc}
${BidPlanGroupFieldsFragmentDoc}`;
export const PlanBasedBidPackagePage_OriginatingProjectDocument = gql`
    query PlanBasedBidPackagePage_OriginatingProject($id: ID!) {
  project(id: $id) {
    ...PlanBasedBidPackagePage_OriginatingProject
  }
}
    ${PlanBasedBidPackagePage_OriginatingProjectFragmentDoc}`;

/**
 * __usePlanBasedBidPackagePage_OriginatingProjectQuery__
 *
 * To run a query within a React component, call `usePlanBasedBidPackagePage_OriginatingProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBasedBidPackagePage_OriginatingProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBasedBidPackagePage_OriginatingProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanBasedBidPackagePage_OriginatingProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanBasedBidPackagePage_OriginatingProjectQuery, PlanBasedBidPackagePage_OriginatingProjectQueryVariables> & ({ variables: PlanBasedBidPackagePage_OriginatingProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanBasedBidPackagePage_OriginatingProjectQuery, PlanBasedBidPackagePage_OriginatingProjectQueryVariables>(PlanBasedBidPackagePage_OriginatingProjectDocument, options);
      }
export function usePlanBasedBidPackagePage_OriginatingProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanBasedBidPackagePage_OriginatingProjectQuery, PlanBasedBidPackagePage_OriginatingProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanBasedBidPackagePage_OriginatingProjectQuery, PlanBasedBidPackagePage_OriginatingProjectQueryVariables>(PlanBasedBidPackagePage_OriginatingProjectDocument, options);
        }
// @ts-ignore
export function usePlanBasedBidPackagePage_OriginatingProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidPackagePage_OriginatingProjectQuery, PlanBasedBidPackagePage_OriginatingProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidPackagePage_OriginatingProjectQuery, PlanBasedBidPackagePage_OriginatingProjectQueryVariables>;
export function usePlanBasedBidPackagePage_OriginatingProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidPackagePage_OriginatingProjectQuery, PlanBasedBidPackagePage_OriginatingProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidPackagePage_OriginatingProjectQuery | undefined, PlanBasedBidPackagePage_OriginatingProjectQueryVariables>;
export function usePlanBasedBidPackagePage_OriginatingProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidPackagePage_OriginatingProjectQuery, PlanBasedBidPackagePage_OriginatingProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanBasedBidPackagePage_OriginatingProjectQuery, PlanBasedBidPackagePage_OriginatingProjectQueryVariables>(PlanBasedBidPackagePage_OriginatingProjectDocument, options);
        }
export type PlanBasedBidPackagePage_OriginatingProjectQueryHookResult = ReturnType<typeof usePlanBasedBidPackagePage_OriginatingProjectQuery>;
export type PlanBasedBidPackagePage_OriginatingProjectLazyQueryHookResult = ReturnType<typeof usePlanBasedBidPackagePage_OriginatingProjectLazyQuery>;
export type PlanBasedBidPackagePage_OriginatingProjectSuspenseQueryHookResult = ReturnType<typeof usePlanBasedBidPackagePage_OriginatingProjectSuspenseQuery>;
export type PlanBasedBidPackagePage_OriginatingProjectQueryResult = Apollo.QueryResult<PlanBasedBidPackagePage_OriginatingProjectQuery, PlanBasedBidPackagePage_OriginatingProjectQueryVariables>;
export const PlanBasedBidPackagePageDocument = gql`
    query PlanBasedBidPackagePage($id: ID!) {
  bidPackageGroup(id: $id) {
    id
    bidPackages {
      ...PlanBasedBidPackagePage_BidPackage
    }
  }
}
    ${PlanBasedBidPackagePage_BidPackageFragmentDoc}`;

/**
 * __usePlanBasedBidPackagePageQuery__
 *
 * To run a query within a React component, call `usePlanBasedBidPackagePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBasedBidPackagePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBasedBidPackagePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanBasedBidPackagePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanBasedBidPackagePageQuery, PlanBasedBidPackagePageQueryVariables> & ({ variables: PlanBasedBidPackagePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanBasedBidPackagePageQuery, PlanBasedBidPackagePageQueryVariables>(PlanBasedBidPackagePageDocument, options);
      }
export function usePlanBasedBidPackagePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanBasedBidPackagePageQuery, PlanBasedBidPackagePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanBasedBidPackagePageQuery, PlanBasedBidPackagePageQueryVariables>(PlanBasedBidPackagePageDocument, options);
        }
// @ts-ignore
export function usePlanBasedBidPackagePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidPackagePageQuery, PlanBasedBidPackagePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidPackagePageQuery, PlanBasedBidPackagePageQueryVariables>;
export function usePlanBasedBidPackagePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidPackagePageQuery, PlanBasedBidPackagePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidPackagePageQuery | undefined, PlanBasedBidPackagePageQueryVariables>;
export function usePlanBasedBidPackagePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidPackagePageQuery, PlanBasedBidPackagePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanBasedBidPackagePageQuery, PlanBasedBidPackagePageQueryVariables>(PlanBasedBidPackagePageDocument, options);
        }
export type PlanBasedBidPackagePageQueryHookResult = ReturnType<typeof usePlanBasedBidPackagePageQuery>;
export type PlanBasedBidPackagePageLazyQueryHookResult = ReturnType<typeof usePlanBasedBidPackagePageLazyQuery>;
export type PlanBasedBidPackagePageSuspenseQueryHookResult = ReturnType<typeof usePlanBasedBidPackagePageSuspenseQuery>;
export type PlanBasedBidPackagePageQueryResult = Apollo.QueryResult<PlanBasedBidPackagePageQuery, PlanBasedBidPackagePageQueryVariables>;